module.exports = __webpack_public_path__ + "img/wireless-bluetooth-1.9bdfaa6d.png";